<template>
  <div class="my-item z-info">
    <template>
      <div style="min-height: 400px;">
        <Row :gutter="30">
          <Col :md="12" :xl="8" :xxl="6" class="w-20">
          <div class="addPro pro" @click="addCert">
            <i class="icon iconfont icon-jia3"></i>
            <span>添加证件</span>
          </div>
          </Col>
          <template v-if="CarList.length">
            <Col :md="12" :xl="8" :xxl="6" v-for="(item, index) in CarList" :key="'releaseInt-' + index" class="w-20">
            <div class="pro">
              <div class="pro-top">
                <div class="pro-top-l">
                  <p>姓名：{{item.firstName}}</p>
                  <p>职务：{{item.jobTitle}}</p>
                  <p>身份证号：{{item.idCard}}</p>
                  <p>电话：{{item.tel}}</p>
                </div>
              </div>
              <div class="pro-tool" v-if="item.changeState !== 1">
                <div class="pro-tool-item" @click="editModal(item)" style="color:#1890ff">编辑</div>
                <div class="pro-tool-line"></div>
                <div class="pro-tool-item z-del">
                  <Poptip confirm title="您确认删除这条内容吗？" @on-ok="delItem(item)" style="color:#ff0000">删除</Poptip>
                </div>
              </div>
              <div class="pro-tool" v-else>
                <div class="pro-tool-item" @click="$Message.warning('等待主办审核');" style="color:#1890ff">编辑</div>
                <div class="pro-tool-line"></div>
                <div class="pro-tool-item" @click="$Message.warning('等待主办审核');" style="color:#ff0000">删除</div>
              </div>
            </div>
            </Col>
          </template>
        </Row>
        <!-- <div class="my-page" v-if="totalCount > pageSize">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div> -->
      </div>
    </template>
    <addCert :show="carShow" :yesNumber="yesNumber" :NoNumber="NoNumber" @close="closeModal"></addCert>
    <editCert :show="editShow" :editInfo="editInfo" :type="0" @close="closeEdit"></editCert>
    <addCertExcel :addExcelShow="addExcelShow" @close="closeExcel" :init="init"></addCertExcel>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import addCert from "./add-cert";
import editCert from "./edit-cert";
import addCertExcel from "./add-cret-excel";
export default {
  name: "exhibition-car-yes",
  props: ["addShow"],
  data() {
    return {
      editShow: false,
      editInfo: null,
      addExcelShow: false,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      timer: null,
      carShow: false,
      CarList: [],
      yesNumber: 0, //已确认的信息条数
      NoNumber: 0,
    };
  },
  watch: {
    addShow(val) {
      // alert(val)
      // this.addCert();
      // if(val){
      //
      // }
    },
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition",
      joinInfo: "loginModule/getJoinInfo",
    }),
    header() {
      return this.$store.state.header;
    },
  },
  components: {
    addCert,
    editCert,
    addCertExcel,
  },
  created() {
    this.init();
  },
  methods: {
    closeModal() {
      // 关闭弹框
      this.carShow = false;
      this.$emit("closeModal");
    },
    closeExcel() {
      // 关闭下载弹框
      this.addExcelShow = false;
    },
    closeEdit() {
      this.editShow = false;
      this.init();
    },
    addCert() {
      // if (this.joinInfo.boothArea<9&&this.yesNumber+this.NoNumber>2){
      //   this.$Message.error("申请证件数不能超过两张");
      //   return
      // }
      // if (this.joinInfo.boothArea>=9&&this.yesNumber+this.NoNumber>=Math.round(this.joinInfo.boothArea/9)*3&&Math.round(this.joinInfo.boothArea/9)*3!=0){
      //   this.$Message.error("申请证件数已达上限");
      //   return
      // }
      this.carShow = true;
    },
    addCert1() {
      // if (this.joinInfo.boothArea<9&&this.yesNumber+this.NoNumber>2){
      //   this.$Message.error("申请证件数不能超过两张");
      //   return
      // }
      // if (this.joinInfo.boothArea>=9&&this.yesNumber+this.NoNumber>=Math.round(this.joinInfo.boothArea/9)*3&&Math.round(this.joinInfo.boothArea/9)*3!=0){
      //   this.$Message.error("申请证件数已达上限");
      //   return
      // }
      this.addExcelShow = true;
    },
    editModal(item) {
      this.editShow = true;
      this.editInfo = item;
    },
    delItem(item) {
      // 删除
      const req = {
        data: {
          id: item.id,
          jonId: this.joinInfo.joinId,
          exhibitionId: this.exhibition.id,
        },
      };
      this.$http
        .delete(`/api/DeExCardDown/DeleteUp`, {
          data: req.data,
          ...this.header,
        })
        .then((res) => {
          if (res.status === 200 && res.data.successed) {
            this.$Message.success("删除成功，请等待审核！");
            this.init();
          } else {
            this.$Message.error("删除失败，请重新尝试");
          }
        });
    },
    init() {
      // this.$http.get(`/api/DeExCardDown/GetDeExCardDownAuditByJoin?JoinId=${this.joinInfo.joinId}`,this.header)
      //         .then(res=>{
      //           if(res.status === 200 && res.data.length){
      //             this.NoNumber=  res.data.length
      //           }
      //         })
      this.$http
        .post(
          `/api/DeExCardUp/GetList`,
          { JoinId: this.joinInfo.joinId },
          this.header
        )
        .then((res) => {
          if (res.status === 200 && res.data.length) {
            this.CarList = res.data;
            this.yesNumber = this.CarList.length;
          } else {
            this.CarList = [];
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.my-item {
  min-width: 600px;
  padding: 24px;

  &-box {
    background-color: #fff;
    margin-bottom: 30px;
  }

  .addPro {
    padding: 40px;
    .icon {
      font-size: 60px;
      text-align: center;
      display: block;
      color: #999;
    }
    span {
      display: block;
      font-size: 18px;
      color: #999;
      text-align: center;
      position: relative;
      top: -5px;
    }
  }
  .pro {
    margin-bottom: 20px;
    position: relative;
    height: 210px;
    background-color: #fafafa;
    box-shadow: 0px 2px 6px 0px rgba(136, 156, 176, 0.1);
    &-top {
      width: 100%;
      background: #fff;
      padding: 20px;
      display: flex;
      height: 162px;
      padding-bottom: 20px;
      &-l {
        width: 100%;
        h3 {
          font-size: 18px;
          font-weight: 600;
          line-height: 20px;
          color: #333;
          padding-bottom: 10px;
        }
        p {
          font-size: 14px;
          line-height: 16px;
          padding: 8px 0;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    &-tool {
      display: flex;
      height: 48px;
      align-items: center;
      justify-content: space-around;
      background-color: #f7f9fa;

      &-item {
        flex: 1;
        line-height: 48px;
        font-size: 14px;
        color: #808080;
        cursor: pointer;
        text-align: center;
        &:hover {
          color: #1890ff;
        }

        &.z-del {
          &:hover {
            color: #f00;
          }
        }
      }

      &-line {
        background-color: #e8e8e8;
        font-size: 20px;
        width: 1px;
        height: 22px;
        background-color: #e8e8e8;
      }
    }
  }

  .my-page {
    padding-bottom: 50px;
  }
}
</style> 
